import { JSX } from 'react';
export interface IProductActivationStepper {
	header: string;
	description?: string;
	steps: IActivationStep;
}
export interface IActivationStep {
	[key: string]: {
		header: string;
		description?: string;
		status: StepperState;
		stepVisible?: boolean;
		infoCard?: {
			header: string;
			description: string;
		};
	};
}

export interface IProductActivation {
	onClose?: () => void;
	children: JSX.Element;
	stepperData: IActivationStep;
	previousHandler?: () => void;
	nextHandler: () => void;
	header: string;
	description?: string;
	disablePreviousButton?: boolean;
	disableNextButton?: boolean;
	displayFullScreen?: boolean;
	displayFullWidthContent?: boolean;
	nextButtonText?: string;
	prevButtonText?: string;
	hideFooter?: boolean;
	hidePreviousBtn?: boolean;
	displayFullContent?: boolean;
}

export type FieldInfoData = {
	question: string;
	answer?: string;
	imageUrl?: string;
	htmlContent?: JSX.Element;
};

export interface IProductActivationInfo {
	infoList: Array<FieldInfoData>;
}

export enum StepperState {
	IN_PROGRESS = 'IN_PROGRESS',
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
	PSEUDO_SUCCESS = 'PSEUDO_SUCCESS',
	ERROR = 'ERROR',
}

export type BusinessCategoryItem = {
	categoryNodeId: string;
	value: string;
	categoryType?: string;
	active?: boolean;
};
